import styled from '@emotion/styled';

import { tokens } from '@hotjar/hotsauce';

interface DotProps {
  isActive: boolean;
  onClick: () => void;
}

interface DotsProps {
  images: string[];
  currentIndex: number;
  onClick: (index: number) => void;
}

const DotsBox = styled.ul`
  padding: 0;
  position: absolute;
  bottom: ${tokens.spacer.x1};
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  list-style-type: none;
`;

const DotBox = styled.li<{ isActive: boolean; onClick: () => void }>`
  cursor: pointer;
  margin: 0 ${tokens.spacer.x1};
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: ${tokens.color.neutral_200};
  ${tokens.transition('background-color', 600)};

  ${({ isActive }) => (isActive ? `background-color: ${tokens.color.ui_active};` : '')},

  &:hover {
    background-color: ${tokens.color.ui_active};
  }
`;

const Dot = ({ isActive, onClick }: DotProps): JSX.Element => {
  return <DotBox isActive={isActive} onClick={() => onClick()} />;
};

export const Dots = ({ images, currentIndex, onClick }: DotsProps): JSX.Element => {
  const handleDotClick = (index: number) => {
    onClick(index);
  };

  return (
    <DotsBox>
      {images.map((img, index) => (
        <Dot key={img} isActive={index === currentIndex} onClick={() => handleDotClick(index)} />
      ))}
    </DotsBox>
  );
};
